export default "__VITE_ASSET__CyNKUx6t__"